<template>
  <MainContent>
    <b-row>
      <b-col cols="12" md="6">
        <LoginWelcomBanner />
      </b-col>
      <b-col cols="12" md="6">
        <LoginEDriveForm />
      </b-col>
    </b-row>
  </MainContent>
</template>
<script>
import { UserService } from "@/services";
import { IAmSmartQrCodeApi } from "@/api";
import Url from "url-parse";
import { MaintainNewsApi } from '@/api';
import LoginWelcomBanner from "../components/login/LoginWelcomBanner.vue";
import LoginEDriveForm from "../components/login-edrive/LoginEDriveForm.vue";
import InfoNewsTable from "../../../../components/info/InfoNewsTable.vue";

export default {
  components: {
    InfoNewsTable,
    LoginEDriveForm,
    LoginWelcomBanner
  },
  data() {
    return {
      identity: {
        username: "",
        password: "",
      },
      loginAsOptions: [],
      invitationCode: "",
      showSignModal: false,
      fileId: null,
      file: [],
      fileName: '',
      newsList: [],
      pagination: {
        page: 0,
        size: 15,
        sort: 'date desc'
      }
    };
  },
  async created() {
    // var lang = this.$route.query.lang;
    // if (lang) {
    //   this.$root.$i18n.locale = lang;
    // }
    // await this.updateList();

    // try {
    //   await UserApi.getCurrentUser();
    //   window.location.href = process.env.VUE_APP_EDRIVE_URL;
    // } catch (e) {}
  },
  // watch: {
  //   '$i18n.locale': {
  //     handler() {
  //       this.updateList();
  //     }
  //   }
  // },
  methods: {
    async login(evt) {
      const loginMethod = (evt.submitter || evt.currentTarget).dataset.method;
      let url = null;

      if (loginMethod === "iam-smart") {
        url = await this.iamSmartLogin();

      } else {
        url = await this.defaultLogin();
      }
      if(url){
        window.location.assign(url);
      }
    },
    //#region REVIEW default Login
    async defaultLogin() {
      const { username, password } = this.identity;
      let lang = this.$i18n.locale.replace(/_/i, '-');
      var res = await UserService.loginESH(username, password, lang);
      if(res?.response?.data.includes("ERR_AUTH_0008")){ //E-cert is not present
        this.showSignModal = true;
        return '';
      }else{
        return process.env.VUE_APP_ESS_URL;
      }
    },
    //#endregion
    async iamSmartLogin() {
      let lang;
      var result;
      switch (this.$i18n.locale) {
        case "zh_hk":
          lang = "zh-HK";
          result = await IAmSmartQrCodeApi.getQrCodeUrlHk();
          break;
        case "zh_cn":
          lang = "zh-CN";
          result = await IAmSmartQrCodeApi.getQrCodeUrlCn();
          break;
        default:
          lang = "en-US";
          result = await IAmSmartQrCodeApi.getQrCodeUrlUs();
      }

      const url = new Url(result.data.url, true);
      url.set("query", {
        ...url.query,
        lang,
      });
      return url.toString();
    },
    async getQrCode() {
      console.log("this.invitationCode", this.invitationCode);
      let lang = this.$i18n.locale;
      const res = await IAmSmartQrCodeApi.getQrCodeForInvite(lang);
      window.location.assign(res.data.url);
    },
    /*openIAmSmartApp(){
      document.location.assign(process.env.VUE_APP_IAM_SMART_APP_URL_SCHEME + "://profile?ticketID=1234");
    },*/
    onClickIamSmartLink() {
      if (this.$i18n.locale === "zh_cn") {
        window.open("https://www.iamsmart.gov.hk/sc/");
      } else if (this.$i18n.locale === "zh_hk") {
        window.open("https://www.iamsmart.gov.hk/tc/");
      } else {
        window.open("https://www.iamsmart.gov.hk/en/");
      }
    },
    openModal() {
      this.$bvModal.show("registration-professional-activate-modal");
    },
    openOwnerAssistantModal() {
      this.$bvModal.show("activate-owner-assistant-modal");
    },
    goToRegister() {
      this.$router.push({
        name: "ERegistrationProfessionalActivate",
      });
    },
    ownerAssistantEcertActivate() {
      this.$router.push({
        name: 'LoginIAMSmartInvitationView',
        params:{
          ecert : true
        }
      });
    },
    isDayTime() {
      var nowTime = moment().hour()
      if(nowTime >= 6 && nowTime < 18) return true;
      else return false;
    },
    setupInitialPwdCode() {
      this.$router.push({
        name: 'LoginActivationKeyView'
      });
    },
    signComplete() {
      //ECounterApi.SendBatchSignNotification(this.realSubmitId);
      this.fetchFiles();
    },
    async updateList(pageable) {
      const { data: newsList } = await MaintainNewsApi.getLatestNewstList(
          pageable || this.pagination
      );
      this.newsList = newsList.content;
      this.pagination = newsList.pagination;

      this.newsList = this.newsList.filter(row =>
              row.type == 'system'
          // console.log("diffDay", moment(row.date).format('YYYY-MM-DD'), moment().duration(moment().format('YYYY-MM-DD').diff(moment(row.date).format('YYYY-MM-DD'))).asDays())
          // this.$moment.duration(this.$moment().diff(row.date)).asDays() <=1
      )

      if (this.$i18n.locale == 'zh_hk') {
        this.newsList = this.newsList.filter(row => row.language == 'zh_hk' )
      }
      else if (this.$i18n.locale == 'zh_cn') {
        this.newsList = this.newsList.filter(row => row.language == 'zh_cn' )
      }
      else {
        this.newsList = this.newsList.filter(row => row.language == 'en' )
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.registration-professional-activate {
  padding: 50px 0;
  justify-content: space-around;
  .register {
    width: 200px;
    height: 150px;
    color: #fff;
    line-height: 150px;
    /*padding-top: 50px;*/
    text-align: center;
    display: table-cell;
    /*font-weight: 800;*/
    background-color: #005e97;
    border-radius: 0.25rem;
    cursor: pointer;
  }
  .login .btn_text {
    /*width: 200px !important;*/
    /*font-weight: 800 !important;*/
    /*white-space: normal !important;*/
  }
  .login .btn_text span {
    white-space: normal !important;
  }
}
.info-btn {
  margin-bottom: 30px;
}
.info-btn button {
  color: #fff;
  padding: 8px;
  border-radius: 0.25rem;
  background-color: #005d99;
  border: 1px;
  font-weight: 400 !important;
}
.modelStyle .bg-secondary {
  background-color: #005d99 !important;
}
</style>

<i18n src="@/locales/login.locale"></i18n>

<i18n src="@/locales/esh.locale"></i18n>

